import type { AnyAction } from 'redux'

import { getSubscribeFlow, getUnsubscribeFlow } from 'apps/systemKeywords/systemKeywordsActions'
import { ISystemKeywordsState } from 'apps/systemKeywords/systemKeywordsInterfaces'

export const getInitialSystemKeywordsState = (): ISystemKeywordsState => ({
  id: null,
  name: '',
  isFetched: false,
  fetching: false,
})

const initialState = getInitialSystemKeywordsState()

export function systemKeywordsReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case getSubscribeFlow.pending.type:
    case getUnsubscribeFlow.pending.type: {
      return { ...state, fetching: true }
    }
    case getSubscribeFlow.fulfilled.type:
    case getUnsubscribeFlow.fulfilled.type: {
      const { id, name } = action?.payload ?? {}
      return { ...state, id, name, isFetched: true, fetching: false }
    }
  }
  return state
}
